import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  title: {
    id: 'Landing.title',
    defaultMessage: 'Capture Every Moment, Create Lasting Memories',
  },
  subtitle: {
    id: 'Landing.subtitle',
    defaultMessage: 'Welcome to Party Guestbook - The Future of Guestbooks',
  },
  intro: {
    id: 'Landing.intro',
    defaultMessage:
      'In a world where every moment is precious, Party Guestbook transforms the way we remember our most special occasions. From weddings to funerals, birthdays to graduations, our digital guestbook ensures that no memory is left behind.',
  },
  section1Heading: {
    id: 'Landing.section1Heading',
    defaultMessage: 'Instant Memories with a Scan',
  },
  section1Body: {
    id: 'Landing.section1Body',
    defaultMessage:
      "Say goodbye to traditional guestbooks. With Party Guestbook, your guests can leave heartfelt messages and fun photos by simply scanning a QR code. It's guest interaction made modern, easy, and full of life.",
  },
  section2Heading: {
    id: 'Landing.section2Heading',
    defaultMessage: 'For Every Occasion',
  },
  section2Body: {
    id: 'Landing.section2Body',
    defaultMessage:
      "Whether it's the joy of a wedding, the celebration of a birthday, or the solemn memory of a loved one, our app is designed to capture the essence of every event. Customize your digital guestbook to match the theme and emotion of your occasion.",
  },
  section3Heading: {
    id: 'Landing.section3Heading',
    defaultMessage: 'Cherish and Share',
  },
  section3Body: {
    id: 'Landing.section3Body',
    defaultMessage:
      'Not just a digital copy, but a treasure trove of memories you can hold. Party Guestbook offers professional creation of your guestbook, turning digital messages and photos into a beautifully crafted book that you can cherish forever.',
  },
  actionTitle: {
    id: 'Landing.actionTitle',
    defaultMessage: "Your Memories Await! Let's Get Started Together",
  },
  actionSubtitle: {
    id: 'Landing.actionSubtitle',
    defaultMessage:
      "Dive into a new chapter of capturing and cherishing life's moments with Party Guestbook. Join us now, and let's create a guestbook that tells the story of your special events in the most memorable way.",
  },
  actionButton: {
    id: 'Landing.actionButton',
    defaultMessage: "Let's Begin",
  },
})
